<template>
  <page-skeleton>
    <template slot="header-left">
      <span :class="['header-tabs', {active: active === 1}]" @click="() => handleHeaderTabs(1)">文章</span>
      <span :class="['header-tabs', {active: active === 2}]" @click="() => handleHeaderTabs(2)">分类</span>
      <span :class="['header-tabs', {active: active === 3}]" @click="() => handleHeaderTabs(3)">标签</span>
    </template>

    <template slot="container">
      <div class="operation">
        <div v-show="active === 1" class="operation-article">
          <div>
            <el-input v-model="articleParameter.searchName" placeholder="输入标题关键字" size="medium" suffix-icon="el-icon-search" style="width: 200px;" @change="getArticleList" />
            <div class="select-picker">
              <el-select v-model="articleParameter.dateType" size="medium" placeholder="请选择">
                <el-option label="创建时间" :value="1" />
                <el-option label="更新时间" :value="2" />
              </el-select>
              <el-date-picker v-model="articleParameter.date" type="datetimerange" size="medium" range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" value-format="yyyy-MM-dd HH:mm:ss" @change="changeDatePicker" />
            </div>
            <el-cascader size="medium" placeholder="请选择分类" :options="classificationOptions" :props="{ value: 'classificationId', label: 'name', children: 'childList', emitPath: false }" :show-all-levels="false" filterable clearable @change="changeClassificationOptions">
              <template slot-scope="{ node, data }">
                <span>{{ data.name }}</span>
                <span v-if="!node.isLeaf"> ({{ data.childList.length }}) </span>
              </template>
            </el-cascader>
          </div>
          <el-button type="primary" size="medium" round @click="addArticle">添加文章</el-button>
        </div>
        <div v-show="active === 2">
          <el-button type="primary" size="medium" round @click="addClassification">添加分类</el-button>
        </div>
        <div v-show="active === 3">
          <el-button type="primary" size="medium" round @click="addLabel">添加标签</el-button>
        </div>
      </div>

      <div class="table-body">
        <!-- 文章 -->
        <el-table v-show="active === 1" :data="articleData" height="100%" style="width: 100%">
          <el-table-column prop="title" show-overflow-tooltip label="标题" />
          <el-table-column prop="fullName" show-overflow-tooltip label="分类" />
          <el-table-column prop="labelName" show-overflow-tooltip label="标签" />
          <el-table-column show-overflow-tooltip label="创建时间">
            <template slot-scope="{row}">
              {{formatDate(row.createDate)}}
            </template>
          </el-table-column>
          <el-table-column label="更新时间">
            <template slot-scope="{row}">
              {{formatDate(row.modifyDate)}}
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态">
            <template slot-scope="{row}">
              <span v-if="row.status === 1" style="color: #99c41c;">启用</span>
              <span v-if="row.status === 0" style="color: #f56c6c;">禁用</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="{row}">
              <el-button type="text" @click="() => editArticle(row)">编辑</el-button>
              <el-popconfirm title="是否确定删除此文章？" class="el-popconfirm" @confirm="() => deleteArticle(row.id)">
                <el-button type="text" slot="reference">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分类 -->
        <el-table v-show="active === 2" :data="classificationData" ref="multipleTable" row-key="id" :tree-props="{children: 'childList'}" style="width: 100%" height="100%">
          <el-table-column show-overflow-tooltip prop="name" label="分类名称" />
          <el-table-column prop="labelName" label="标签" />
          <el-table-column prop="num" label="文章数量" />
          <el-table-column fixed="right" v-slot="{row}" label="操作" width="180">
            <el-button type="text" size="medium" @click="() => addChildrenClassification(row)">添加子分类</el-button>
            <el-button type="text" size="medium" @click="() => editClassification(row)">编辑</el-button>
            <el-popconfirm title="是否确定删除此分类？" class="el-popconfirm" @confirm="() => deleteClassification(row)">
              <el-button type="text" slot="reference">删除</el-button>
            </el-popconfirm>
          </el-table-column>
        </el-table>

        <!-- 标签 -->
        <el-table v-show="active === 3" :data="labelData" height="100%" style="width: 100%">
          <el-table-column prop="labelName" label="标签名称" />
          <el-table-column prop="num" label="文章数量" />
          <el-table-column label="操作" width="180">
            <template slot-scope="{row}">
              <el-button type="text" @click="() => editLabel(row)">编辑</el-button>
              <el-popconfirm title="是否确定删除此标签？" class="el-popconfirm" @confirm="() => deleteLabel(row)">
                <el-button type="text" slot="reference">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </template>

    <template slot="footer-right">
      <el-pagination background  :page-sizes="[20, 50, 100, 200, 500]"  layout="total, sizes, prev, pager, next, jumper" :total="total" class="el-pagination" @size-change="sizeChange" @current-change="currentChange" />
      <!-- <el-pagination background :page-sizes="[20, 50, 100, 200, 500]" layout="prev, pager, next, sizes" :total="total" @size-change="sizeChange" @current-change="currentChange" /> -->
    </template>

    <!-- 添加/编辑文章对话框 -->
    <el-dialog :title="`${articleDialogTitle}文章`" :visible.sync="visibleArticleDialog" width="68%" :before-close="closeArticleDialog">
      <el-form ref="articleForm" :model="articleForm" :rules="articleRules" label-width="100px">
        <el-form-item label="标题" prop="title">
          <el-input v-model="articleForm.title" size="medium" :max="500" class="default-width" placeholder="请输入标题" />
        </el-form-item>
        <el-form-item label="副标题" prop="subTitle">
          <el-input v-model="articleForm.subTitle" size="medium" :max="500" class="default-width" placeholder="请输入副标题" />
        </el-form-item>
        <el-form-item label="标签" prop="labelIds">
          <el-select v-model="articleForm.labelIds" multiple clearable size="medium" class="default-width" placeholder="请选择">
            <el-option v-for="item in labelOptionIds" :key="item.id" :label="item.labelName" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="分类" prop="classificationId">
          <el-cascader v-model="articleForm.classificationId" size="medium" placeholder="请选择分类" :options="classificationOptions" :props="{ value: 'classificationId', label: 'name', children: 'childList', emitPath: false }" :show-all-levels="false" filterable clearable style="width: 100%;">
            <template slot-scope="{ node, data }">
              <span>{{ data.name }}</span>
              <span v-if="!node.isLeaf"> ({{ data.childList.length }}) </span>
            </template>
          </el-cascader>
        </el-form-item>
        <el-form-item label="封面图" prop="imgUrl">
          <el-upload class="classification-uploader" action="#" :show-file-list="false" :before-upload="beforeClassificationUpload">
            <img v-if="articleForm.imgUrl" :src="articleForm.imgUrl" class="classification">
            <i v-else class="el-icon-plus classification-uploader-icon" />
            <div v-if="articleForm.imgUrl" slot="tip" class="el-upload-tip" @click="deleteClassificationImg">删除</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="视频链接" prop="videoPath">
          <el-input v-model="articleForm.videoPath" :max="3000" size="medium" class="default-width" placeholder="请输入视频链接" />
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <rich-editor :value="articleForm.content" :disabled="isDisabledEditor" style="width:100%" @input="inputRichEditorValue" />
        </el-form-item>
        <el-form-item label="是否启用" prop="status">
          <el-switch v-model="articleForm.status" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="closeArticleDialog">取 消</el-button>
        <el-button :loading="articleLoading" type="primary" size="medium" @click="confirmArticleDialog">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 添加/编辑分类对话框 -->
    <el-dialog :title="`${classificationDialogTitle}分类`" :visible.sync="visibleClassificationDialog" width="28%" :before-close="closeclassificationDialog">
      <el-form ref="classificationForm" :model="classificationForm" :rules="classificationRules" label-width="100px">
        <el-form-item label="分类名称" prop="name">
          <el-input v-model="classificationForm.name" size="medium" placeholder="请输入分类名称" />
        </el-form-item>
        <el-form-item v-if="['添加', '编辑'].includes(classificationDialogTitle) && +classificationForm.level === 1" label="标签" prop="labelId">
          <el-select v-model="classificationForm.labelId" size="medium" style="width: 100%" placeholder="请选择">
            <el-option v-for="item in labelSelect" :key="item.id" :label="item.labelName" :value="item.id" />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="closeclassificationDialog">取 消</el-button>
        <el-button :loading="classificationLoading" type="primary" size="medium" @click="confirmclassificationDialog">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 添加/编辑标签 -->
    <el-dialog :title="`${labelDialogTitle}标签`" :visible.sync="visibleLabelDialog" width="28%" :before-close="closeLabelDialog">
      <el-form ref="labelForm" :model="labelForm" :rules="labelRules" label-width="100px">
        <el-form-item label="标签名称" prop="labelName">
          <el-input v-model="labelForm.labelName" size="medium" placeholder="请输入标签名称" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="closeLabelDialog">取 消</el-button>
        <el-button :loading="labelLoading" type="primary" size="medium" @click="confirmLabelDialog">确 定</el-button>
      </span>
    </el-dialog>
  </page-skeleton>
</template>

<script>
import _ from 'lodash'
import API from '@/api'
import moment from 'moment'
import RichEditor from './components/RichEditor.vue'
import PageSkeleton from './components/PageSkeleton.vue'

export default {
  name: 'operation_copywriting',
  components: {
    RichEditor,
    PageSkeleton
  },
  data() {
    return {
      active: 1, // 头部tabs当前选中项

      articleParameter: {
        searchName: undefined, // 搜索关键字
        date: [], // 日期时间选择器绑定的值（请求前需删除）
        dateType: 1, // 1.创建时间 2.更新时间
        startTime: undefined, // 开始时间
        endTime: undefined, // 结束时间
        classificationId: undefined, // 分类ID
        labelId: undefined, // 标签ID
        labelName: undefined, // 标签名称
        pageNumber: 1, // 当前页
        pageSize: 20 // 每页显示条数
      }, // 获取文章数据的请求参数
      classificationOptions: [], // 分类级联选择器数据源
      labelOptionIds: [], // 标签下拉选择器数据源
      articleData: [], // 文章-表格数据源
      visibleArticleDialog: false, // 是否显示添加/编辑文章的对话框
      articleDialogTitle: undefined, // 添加/编辑文章的对话框标题
      articleForm: {
        title: undefined, // 标题
        subTitle: undefined, // 副标题
        labelIds: [], // 标签ID
        classificationId: undefined, // 分类ID
        imgUrl: undefined, // 封面图
        videoPath: undefined, // 视频链接
        content: undefined, // 内容
        status: false // 状态：0.停用 1.启用（发送前需要转换为数字 📌）
      }, // 添加/编辑文章的对话框表单数据
      articleRules: {
        title: [
          { required: true, message: '请输入标题', trigger: ['blur', 'change'] },
          { min: 1, max: 500, message: '标题长度在 1 到 500 个字符', trigger: ['blur', 'change'] }
        ],
        videoLink: [
          { min: 0, max: 3000, message: '视频链接长度在 1 到 3000 个字符', trigger: ['blur', 'change'] }
        ],
        content: [
          { required: true, message: '请输入文章内容', trigger: ['blur', 'change'] }
        ],
        status: [
          { required: true, message: '请选择是否启用', trigger: ['blur', 'change'] }
        ]
      }, // 添加/编辑文章的对话框表单验证规则
      isDisabledEditor: false, // 是否禁用添加/编辑文章的对话框的富文本框

      classificationParameter: {
        pageNumber: 1,
        pageSize: 20
      }, // 获取分类数据的请求参数
      classificationData: [], // 分类-表格数据源
      visibleClassificationDialog: false, // 是否显示添加/编辑分类对话框
      classificationDialogTitle: undefined, // 添加/编辑分类对话框标题
      classificationForm: {
        parentId: 0, // 父ID
        level: 1, // 级别
        labelId: undefined, // 标签id
        name: undefined, // 添加/编辑的分类名称
        classificationId: undefined, // 编辑的分类ID
        id: undefined // ID
      }, // 添加/编辑分类对话框表单数据
      classificationRules: {
        name: [
          { required: true, message: '请输入分类名称', trigger: ['blur', 'change'] },
          { min: 1, max: 50, message: '标题长度在 1 到 50 个字符', trigger: ['blur', 'change'] }
        ]
      }, // 添加/编辑分类对话框表单验证规则

      labelParameter: {
        pageNumber: 1,
        pageSize: 20
      }, // 获取标签数据的请求参数
      labelData: [], // 标签-表格数据源
      labelSelect: [], // 标签下拉框数据
      visibleLabelDialog: false, // 是否显示添加/编辑标签对话框
      labelDialogTitle: undefined, // 添加/编辑标签对话框标题
      labelForm: {
        id: undefined, // 修改时需要传的ID
        labelName: undefined // 标签名称
      }, // 添加/编辑标签对话框表单数据
      labelRules: {
        labelName: [
          { required: true, message: '请输入标签名称', trigger: ['blur', 'change'] },
          { min: 1, max: 50, message: '标题长度在 1 到 50 个字符', trigger: ['blur', 'change'] }
        ]
      }, // 添加/编辑标签对话框表单验证规则

      total: 0, // 分页总条数

      articleLoading: false,
      classificationLoading: false,
      labelLoading: false
    }
  },
  computed: {
    formatDate() {
      return (date) => {
        return moment(date).format('YYYY/MM/DD hh:mm:ss')
      }
    }
  },
  created() {
    // 先加载分类，加载成功后再请求this.getArticleList()
    this.getClassificationList()
    // this.getArticleList()
    
    // this.getLabelList()
    // this.getLabelSelect()
  },
  methods: {
    // 获取文章数据
    async getArticleList(call = true) {
      try {
        if (call) this.resetArticlePage()
        let newArticleParameter = { ...this.articleParameter }
        delete newArticleParameter.date
        let { data } = await API.getArticleList(newArticleParameter)
        this.articleData = data.list
        this.total = data.total
        this.$tableScrollTop()
      } catch (error) {
        throw new Error(error.message)
      }
    },
    resetArticlePage() {
      this.articleParameter.pageNumber = 1
    },

    // 获取分类数据
    async getClassificationList(call = true) {
      try {
        if (call) this.resetClassificationPage()
        let { data } = await API.getClassificationList(this.classificationParameter)
        this.getArticleList()
        this.deletechildList(data.list)
        this.classificationData = _.cloneDeep(data.list)
        this.classificationOptions = _.cloneDeep(data.list)
        this.total = data.total
        this.$tableScrollTop()
        this.$nextTick(() => {
          this.$refs.multipleTable.doLayout()
        })
      } catch (error) {
        throw new Error(error.message)
      }
    },
    resetClassificationPage() {
      this.classificationParameter.pageNumber = 1
    },
    deletechildList(array) { // 删除最后一级为空的childList字段
      array.forEach((item) => {
        if (!item.childList.length) {
          delete item.childList
        } else {
          this.deletechildList(item.childList)
        }
      })
    },

    // 获取标签数据
    async getLabelList(call = true) {
      try {
        if (call) this.resetLabelPage()
        let { data } = await API.getLabelList(this.labelParameter)
        this.labelData = _.cloneDeep(data.list)
        this.labelOptionIds = _.cloneDeep(data.list)
        this.total = data.total
        this.$tableScrollTop()
      } catch (error) {
        throw new Error(error.message)
      }
    },
    /**
     * 获取标签下拉框数据
     */
    getLabelSelect() {
      API.getLabelList({
        pageNumber: 1,
        pageSize: 500
      }).then(result => {
        this.labelSelect = result.data.list
      })
    },
    resetLabelPage() {
      this.labelParameter.pageNumber = 1
    },

    // tabs点击的回调
    handleHeaderTabs(key) {
      if (this.active === key) return
      this.active = key
      switch (this.active) {
        case 1: // 文章
          this.getArticleList()
          break
        case 2: // 分类
          this.getClassificationList()
          break
        case 3: // 标签
          this.getLabelList()
          break
      }
    },

    // 筛选文章时间选择器触发的回调
    changeDatePicker(date) {
      if (date && date.length === 2) {
        this.articleParameter.startTime = date[0]
        this.articleParameter.endTime = date[1]
      } else {
        this.articleParameter.startTime = undefined
        this.articleParameter.endTime = undefined
      }
      this.getArticleList()
    },

    // 文章分类级联选择器触发的回调
    changeClassificationOptions(value) {
      if (!value) {
        this.articleParameter.classificationId = undefined
      } else {
        this.articleParameter.classificationId = value.toString()
      }
      this.getArticleList()
    },

    // 添加文章
    addArticle() {
      this.articleDialogTitle = '添加'
      this.visibleArticleDialog = true
    },

    // 编辑文章
    async editArticle(row) {
      this.articleDialogTitle = '编辑'
      this.visibleArticleDialog = true
      let { data } = await API.getArticleDetailsById(row.essayId)
      data.status = data.status === 1 ? true : false
      Object.assign(this.articleForm, data)
    },

    // 删除文章
    async deleteArticle(id) {
      let result = await API.deleteArticleById(id)
      if (result.code !== 10000) {
        return this.$message.error(result.message)
      }
      this.getArticleList(false)
      this.$message.success(result.message)
    },

    // 添加/编辑文章对话框中上传文件之前的钩子
    beforeClassificationUpload(file) {
      API.signValue({ directory: 'test/' }).then(({ data }) => {
        let formData = new FormData()
        formData.append('directory', 'test/')
        formData.append('signValue', data)
        formData.append('fileList', file)
        API.uploadFile(formData).then((result) => {
          if (result.code !== 10000) {
            return this.$message.error(result.message)
          }
          this.articleForm.imgUrl = result.data
        })
      })
      return false
    },

    // 添加/编辑文章对话框中删除已上传的上传文件
    deleteClassificationImg() {
      this.articleForm.imgUrl = undefined
    },

    // 富文本主体内容
    inputRichEditorValue(value) {
      this.articleForm.content = value
    },

    // 添加/编辑文章对话框关闭按钮的回调
    closeArticleDialog() {
      this.visibleArticleDialog = false
      this.$refs.articleForm.resetFields()
    },

    // 添加/编辑文章对话框确定按钮的回调
    confirmArticleDialog() {
      this.$refs.articleForm.validate(async (valid) => {
        try {
          if (!valid) return
          this.articleLoading = true
          let newArticleForm = _.cloneDeep(this.articleForm)
          newArticleForm.status = newArticleForm.status ? 1 : 0
          let result
          if (this.articleDialogTitle === '添加') {
            delete newArticleForm.id
            result = await API.addArticle(newArticleForm)
          }
          if (this.articleDialogTitle === '编辑') {
            result = await API.updateArticle(newArticleForm)
          }
          if (result.code !== 10000) {
            this.articleLoading = false
            return this.$message.error(result.message)
          }
          this.getArticleList()
          this.closeArticleDialog()
          this.articleLoading = false
          this.$message.success(result.message)
        } catch (error) {
          this.articleLoading = false
          throw new Error(error.message)
        }
      })
    },

    // 添加分类
    addClassification() {
      this.classificationDialogTitle = '添加'
      this.visibleClassificationDialog = true
    },

    // 添加子分类
    addChildrenClassification(row) {
      this.classificationForm.parentId = row.classificationId // 父ID
      this.classificationForm.level = row.level + 1 // 级别
      this.classificationForm.labelId = row.labelId
      this.classificationDialogTitle = `添加【${row.name}】的子`
      this.visibleClassificationDialog = true
    },

    // 编辑分类
    async editClassification(row) {
      this.classificationForm.classificationId = row.classificationId // 分类ID
      this.classificationForm.id = row.id // ID
      this.classificationForm.name = row.name // 分类名称
      this.classificationForm.labelId = row.labelId
      this.classificationForm.level = row.level
      this.classificationDialogTitle = '编辑'
      this.visibleClassificationDialog = true
    },

    // 删除分类
    async deleteClassification(row) {
      let result = await API.deleteClassification(row.classificationId)
      if (result.code !== 10000) {
        return this.$message.error(result.message)
      }
      this.getClassificationList(false)
      this.$message.success(result.message)
    },

    // 添加/编辑分类对话框关闭按钮的回调
    closeclassificationDialog() {
      this.visibleClassificationDialog = false
      this.$refs.classificationForm.resetFields()
      this.classificationForm.parentId = 0
      this.classificationForm.level = 1
      this.classificationForm.classificationId = undefined
      this.classificationForm.id = undefined
      this.classificationForm.labelId = undefined
    },

    // 添加/编辑分类对话框确定按钮的回调
    confirmclassificationDialog() {
      this.$refs.classificationForm.validate(async (valid) => {
        try {
          if (!valid) return
          this.classificationLoading = true
          let result
          if (this.classificationDialogTitle.includes('添加')) {
            let parameter = { ...this.classificationForm }
            delete parameter.classificationId
            delete parameter.id
            result = await API.addClassification(parameter)
          }
          if (this.classificationDialogTitle.includes('编辑')) {
            let parameter = { ...this.classificationForm }
            delete parameter.parentId
            delete parameter.level
            result = await API.updateClassification(parameter)
          }
          if (result && result.code !== 10000) {
            this.classificationLoading = false
            return this.$message.error(result.message)
          }
          this.closeclassificationDialog()
          this.getClassificationList()
          this.classificationLoading = false
          this.$message.success(result.message)
        } catch (error) {
          this.classificationLoading = false
          throw new Error(error.message)
        }

      })
    },

    // 添加标签
    addLabel() {
      this.labelDialogTitle = '添加'
      this.visibleLabelDialog = true
    },

    // 编辑标签
    async editLabel(row) {
      this.labelDialogTitle = '编辑'
      let { data } = await API.getLabelById(row.id)
      this.labelForm.id = row.id
      this.labelForm.labelName = data.labelName
      this.visibleLabelDialog = true
    },

    // 删除标签
    async deleteLabel(row) {
      let result = await API.deleteLabel(row.id)
      if (result.code !== 10000) {
        return this.$message.error(result.message)
      }
      this.getLabelList(false)
      this.getLabelSelect()
      this.$message.success(result.message)
    },

    // 添加/编辑标签对话框关闭按钮的回调
    closeLabelDialog() {
      this.visibleLabelDialog = false
      this.$refs.labelForm.resetFields()
    },

    // 添加/编辑标签对话框确定按钮的回调
    confirmLabelDialog() {
      this.$refs.labelForm.validate(async (valid) => {
        try {
          if (!valid) return
          this.labelLoading = true
          let result
          if (this.labelDialogTitle === '添加') {
            let parameter = this.labelForm
            delete parameter.id
            result = await API.addLabel(parameter)
          }
          if (this.labelDialogTitle === '编辑') {
            result = await API.updateLabel(this.labelForm)
          }
          if (result.code !== 10000) {
            this.labelLoading = false
            return this.$message.error(result.message)
          }
          this.getLabelList()
          this.getLabelSelect()
          this.closeLabelDialog()
          this.labelLoading = false
          this.$message.success(result.message)
        } catch (error) {
          this.labelLoading = false
          throw new Error(error.message)
        }

      })
    },

    // 每页显示条数发生改变时的回调
    sizeChange(size) {
      switch (this.active) {
        case 1:
          this.articleParameter.pageSize = size
          this.getArticleList(false)
          break
        case 2:
          this.classificationParameter.pageSize = size
          this.getClassificationList(false)
          break
        case 3:
          this.labelParameter.pageSize = size
          this.getLabelList(false)
          break
      }
    },

    // 上一页/下一页/当前页发生改变时的回调
    currentChange(current) {
      switch (this.active) {
        case 1:
          this.articleParameter.pageNumber = current
          this.getArticleList(false)
          break
        case 2:
          this.classificationParameter.pageNumber = current
          this.getClassificationList(false)
          break
        case 3:
          this.labelParameter.pageNumber = current
          this.getLabelList(false)
          break
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.header-tabs {
  display: inline-block;
  color: #cdd4dd;
  height: 30px;
  font-size: 14px;
  text-align: center;
  line-height: 30px;
  padding: 0 28px;
  user-select: none;
  cursor: pointer;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  &:hover {
    background-color: #f5f7f7;
  }
}

.operation {
  margin-bottom: 12px;
  .operation-article {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .select-picker {
      display: inline-block;
      margin: 0 15px;
      .el-select {
        width: 108px;
        /deep/.el-input__inner {
          border-right: 0;
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }
      }
      .el-range-editor.el-input__inner {
        border-top-left-radius: 0 !important;
        border-bottom-left-radius: 0 !important;
      }
    }
  }
}

.table-body {
  height: calc(100% - 36px - 12px);
  .el-popconfirm {
    margin-left: 12px;
  }
}

.active {
  color: #fff;
  background-color: #99c41c !important;
}

.default-width {
  width: 100%;
}

.classification-uploader {
  /deep/.el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    vertical-align: text-bottom;
    &:hover {
      border-color: #99c41c;
    }
  }
  .classification-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 108px;
    height: 108px;
    line-height: 108px;
    text-align: center;
  }
  .classification {
    display: block;
    width: 108px;
    height: 108px;
    object-fit: cover;
  }
  .el-upload-tip {
    color: #99c41c;
    width: 108px;
    margin-top: 0;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    user-select: none;
    cursor: pointer;
    &:hover {
      color: #f56c6c;
    }
  }
}
</style>